<template>
  <div class="login-root">
    <div class="container">
      <div class="row">
        <div class="col-lg-8 col-md-8 col-sm-12" v-bind:style="Style1">
          <div class="app-title">
            <h1>门头沟区文化保护传承“六四一”模式</h1>
            <hr />
          </div>
          <!-- <div class="app-sub-title">{{appNameEnglish}}</div> -->
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12" v-bind:style="Style">
          <div class="form">
            <div class="group">
              用户名：
              <el-input
                v-model="user.username"
                size="mini"
                placeholder="请输入内容"
              ></el-input>
            </div>
            <div class="group">
              密码：
              <el-input
                v-model="user.password"
                size="mini"
                show-password
                placeholder="请输入内容"
              ></el-input>
            </div>
            <div class="group">
              确认密码：
              <el-input
                v-model="user.password2"
                size="mini"
                show-password
                placeholder="请输入内容"
              ></el-input>
            </div>

            <div class="group">
              <el-button type="primary" size="mini" plain @click="registerFn()"
                >注册</el-button
              >
              <el-button type="primary" size="mini" plain @click="cancle()"
                >取消</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "register",
  data() {
    return {
      Style: {
        paddingTop: window.innerHeight / 2 - 150 + "px",
      },
      Style1: {
        paddingTop: window.innerHeight / 2 - 150 + "px",
      },
      user: {
        username: "",
        password: "",
        password2: "",
      },
    };
  },
  computed: {},
  components: {},
  methods: {
    cancle() {
      this.user = {
        username: "",
        password: "",
      };
      this.$router.push({ path: "/" });
    },
    registerFn() {
      let that = this;
      if (this.user.username == "" || this.user.password == "") {
        that.$message("不允许空！");
        return;
      }
      if (this.user.password != this.user.password2) {
        that.$message("两次输入密码不一致！");
        return;
      }
      let data = {
        username: this.user.username,
        password: this.user.password,
      };
      this.$axios({
        method: "post",
        url: "/api/user_app/reg/",
        data: data,
      }).then((response) => {
        if (response.data.status == 201) {
          that.$message("注册成功！");
          that.$router.push({ path: "/login" });
        } else if (response.data.status == 400) {
          that.$message(response.data.msg);
        } else {
          that.$message("注册失败！");
        }
      });
    },
  },
  created() {
    let that = this;
    document.onkeyup = function (e) {
      let key = window.event.keyCode;
      if (key === 13) {
        that.registerFn();
      }
    };
  },
  mounted() {
    let username = this.$cookies.get("username");
    if (!username || username != "admin") {
      this.$router.push({ path: "/login" });
    }
  },
};
</script>

<style scoped lang="less" >
.login-root {
  width: 100%;
  height: 100%;
  background: #fff;
  position: fixed;
  top: 0;
  left: 0;
  background-image: url(./bg_pc.jpg);
  background-attachment: fixed;
  background-size: 100% 100%;
  .shadow {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
  }
  .title-root {
    height: 100%;
  }
  .form {
    background-color: rgba(255, 255, 255, 0.1);
    height: 280px;
    margin-left: 50px;
    box-shadow: 3px 3px 5px #000;
    padding: 20px 20px 40px;
    border-radius: 10px;
    .group {
      color: #fff;
      font-weight: bold;
      text-align: right;
      margin: 20px 0;
      /deep/ .ivu-input-wrapper {
        width: 200px;
      }
    }
    .a {
      color: #ccc;
      text-decoration: underline;
      font-size: small;
      vertical-align: bottom;
      margin: 5px;
    }
    .a:hover {
      color: #fff;
      cursor: pointer;
    }
  }
  .app-title {
    h1 {
      font-size: 40px;
      text-shadow: 5px 5px 5px #000;
    }
    hr {
      margin: 0px auto 10px;
      color: #ccc;
    }
  }
  .copyright {
    margin: 20px 0;
    text-align: center;
    color: #fff;
    text-shadow: 5px 5px 5px #000;
  }
  .app-title,
  .app-sub-title {
    text-align: center;
    color: #fff;
    text-shadow: 5px 5px 5px #000;
  }
  .app-sub-title {
    font-size: 20px;
  }
  .el-select {
    width: 60%;
    /deep/.el-input {
      width: 100% !important;
    }
  }
}
/deep/.el-input,
.el-select {
  width: 60%;
}
</style>
